const DEFAULT_PART_SLOTS = 6;

const isValidLimit = (limit) => Number.isInteger(limit) && limit > 0;

const slotQueue = (initialLimit) => {
    const waiting = [];
    const state = { active: 0, limit: initialLimit };
    const admitWaiting = () => {
        while (waiting.length && state.active < state.limit) {
            state.active += 1;
            waiting.shift()();
        }
    };
    return {
        acquire: () => {
            if (state.active < state.limit) {
                state.active += 1;
                return Promise.resolve();
            }
            return new Promise(resolve => waiting.push(resolve));
        },
        release: () => {
            state.active -= 1;
            admitWaiting();
        },
        resize: (limit) => {
            state.limit = limit;
            admitWaiting();
        },
    };
};

export const createPartSlots = (initialLimit) => {
    const queue = slotQueue(initialLimit);
    return {
        run: async (work) => {
            await queue.acquire();
            try {
                return await work();
            } finally {
                queue.release();
            }
        },
        limitTo: (limit) => {
            if (isValidLimit(limit)) queue.resize(limit);
        },
    };
};

export const partSlots = createPartSlots(DEFAULT_PART_SLOTS);
